import { PayloadAction } from '@reduxjs/toolkit'

import { AnyAction } from 'redux'

import { ProductAvailabilitiesListThunkReturnType } from './interfaces'
import { fetchProductAvailabilitiesList } from './productAvailabilityListsThunks'

export const isFulfilledProductAvailabilityAction = (
  action: AnyAction,
): action is PayloadAction<ProductAvailabilitiesListThunkReturnType> => {
  return [fetchProductAvailabilitiesList.fulfilled.type].includes(action.type)
}
